import { ResponseErr } from '../services/AppClient';
import { PackageProcessingResult } from '../types/PackageProcessingResult';

type Document = Pick<PackageProcessingResult, 'packageId' | 'fileName'>;

export const documentProcessingFailureOutcomes = (
    documents: Document[],
    error?: ResponseErr
): PackageProcessingResult[] => {
    // A request timeout may occur after admission; other 4xx responses definitively reject the request.
    const rejected = Boolean(error && error.status >= 400 && error.status < 500 && error.status !== 408);
    const reason = rejected
        ? error?.data?.title || error?.text || 'The processing request was rejected.'
        : `${error?.data?.title || error?.text || 'The request could not be confirmed.'} Refresh document statuses before trying again.`;
    return documents.map(document => ({
        ...document,
        status: rejected ? 'Skipped' : 'Unconfirmed',
        reason
    }));
};
